import {Field} from "@qid/field";
import {SidPhoto} from "./SidPhoto";


export class SID {
  _id?: string;
  name?: string;
  issuer?: string;
  country?: string;
  photos?: SidPhoto[] = [];
  logoUrl?: string;
  idNumberFormat?: string;
  isSystemApproved?: boolean;
  verificationAvailable?: boolean;
  canSkipIdNumberCheck?: boolean;
  allowManualEnterIdNumber?: boolean
  manualFields?: Field[] = [];
  keyName?: string;
  canSkipNameCheck?: boolean;
  doAutoFillEffort?: boolean;
  confirmAutofillFromUser?: boolean;
  variants?: number;
  digilockerDocType?: string;
}
